/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";

export const form_smlouvaODilo = Form({
	id: "smlouva-o-dilo",
	version: "2020-07-r1",
	title: "Smlouva o dílo",
	icon: "book",
	showInMenu: true
}, [
	SectionGroup({}, [
		Section({
			id: "evidencni-cislo-section",
		}, [
			Row({}, [
				FieldText({
					id: "evidencni-cislo",
					label: "Evidenční číslo smlouvy"
				})
			]),
		])
	]),
	// Config sekce
	SectionGroup({
		print: false
	}, [
		Section({
			id: "hodnoty-formulare",
			title: "Hodnoty pro formulář",
		}, [
			// zakaznik
			Row({}, [
				FieldText({
					id: "objednatel-jmeno",
					label: "Jméno objednatele"
				})
			]),
			Row({}, [
				FieldText({
					id: "objednatel-adresa",
					label: "Adresa objednatele"
				})
			]),
			Row({}, [
				FieldText({
					id: "objednatel-narozeni",
					label: "Datum narození objednatele"
				})
			]),
			Row({}, [
				FieldText({
					id: "email-zakaznika",
					label: "Email objednatele"
				})
			]),
			Row({}, [
				FieldText({
					id: "objednatel-telefon",
					label: "Telefon objednatele"
				})
			]),
			//
			Row({}, [
				FieldText({
					id: "predmet-smlouvy",
					label: "Předmět smlouvy"
				})
			]),
			Row({}, [
				FieldText({
					id: "misto-plneni",
					label: "Místo plnění díla"
				})
			]),
			Row({}, [
				FieldText({
					id: "provest-dilo-do",
					label: "Mezní termín provedení díla"
				})
			]),
			//
			Row({}, [
				FieldText({
					id: "podklady-k-provedeni-dila",
					label: "Podklady k provedení díla"
				})
			]),
			//
			Row({}, [
				FieldText({
					id: "cena-dila",
					label: "Cena celého díla (dopsat i Kč vč. DPH)"
				})
			]),
			Row({}, [
				FieldText({
					id: "prvni-zaloha",
					label: "První záloha (dopsat i Kč vč. DPH + datum splatnosti)"
				})
			]),
			Row({}, [
				FieldText({
					id: "druha-zaloha",
					label: "Druhá záloha (dopsat i Kč vč. DPH + datum splatnosti)"
				})
			])
		]),
	]),
	// Obsah smlouvy
	SectionGroup({}, [
		Section({
			id: "smluvni-strany",
			title: "Smluvní strany"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<table style={{
						width: "100%"
					}}>
						<tr style={{
							width: "100%"
						}}>
							<td style={{
								width: "50%",
								lineHeight: "25px"
							}}>
								Tomáš Zimmel<br />
								Ledenická - Škarda 1252, Srubec, 370 06<br />
								IČO: 741 71 364<br />
								DIČ: CZ8503201377<br />
								tel: +420 792 313 446<br />
								e-mail: zimmel@kuchynerondo.cz, ztkuchyne@seznam.cz<br />
								dále jen jako
								"<strong style={{
									fontWeight: "bold"
								}}>
									Zhotovitel
								</strong>"
							</td>
							<td style={{
								width: "50%",
								lineHeight: "25px"
							}}>
								<strong>{data.values["hodnoty-formulare_objednatel-jmeno"] || ""}</strong><br />
								<strong>{data.values["hodnoty-formulare_objednatel-adresa"] || ""}</strong><br />
								datum narození: <strong>{data.values["hodnoty-formulare_objednatel-narozeni"] || ""}</strong><br />
								tel: <strong>{data.values["hodnoty-formulare_objednatel-telefon"] || ""}</strong><br />
								e-mail: <strong>{data.values["hodnoty-formulare_email-zakaznika"] || ""}</strong><br />
								dále jen jako
								"<strong style={{
									fontWeight: "bold"
								}}>
									Objednatel
								</strong>"
							</td>
						</tr>
					</table>
				</>)
			])
		])
	]),
	SectionGroup({}, [
		Section({
			id: "predmet-smlouvy-misto-plneni",
			title: "Článek 1. Předmět smlouvy a místo plnění"
		}, [
			Row({}, [
				// tslint:disable: max-line-length
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Předmětem smlouvy je závazek Zhotovitele provést pro Objednatele řádně a včas, za podmínek stanovených touto smlouvou, dílo: <strong>{data.values["hodnoty-formulare_predmet-smlouvy"] || ""}</strong> tak, aby splňovala a zajišťovala plnou a správnou funkčnost v účelu, ke kterému je určena a měla vlastnosti obvyklé pro daný druh dodávky; dále jen „Dílo“ a tomu odpovídající závazek Objednatele zaplatit Zhotoviteli dohodnutou cenu díla.
						</li>
						<li>
							Místem plnění Díla je <strong>{data.values["hodnoty-formulare_misto-plneni"] || ""}</strong>.
						</li>
					</ol>
				</>)
			])
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "podklady-pro-provedeni-dila",
			title: "Článek 2. Podklady pro provedení Díla"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Podklady k provedení Díla, které jsou součástí této smlouvy, se rozumí:
							<ol style={{
								marginTop: "10px",
								lineHeight: "25px",
								textAlign: "justify",
								listStyleType: "lower-alpha"
							}}>
								<li>
									<strong>{data.values["hodnoty-formulare_podklady-k-provedeni-dila"] || ""}</strong>
								</li>
								<li>
									Detaily jsou dány 3D vizualizací, která byla odsouhlasena Objednatelem a přiložena ke smlouvě (příloha č. 2).
								</li>
							</ol>
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "doba-plneni",
			title: "Článek 3. Doba plnění"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Zhotovitel se zavazuje na základě této smlouvy provést Dílo do <strong>{data.values["hodnoty-formulare_provest-dilo-do"] || ""}</strong>. Zahájení Díla je podmíněna uhrazením zálohy Objednatelem Zhotoviteli.
						</li>
						<li>
							Pokud nebude záloha předána Objednatelem v dohodnutém termínu, prodlužuje se doba zahájení Díla o stejný počet dní, o který se Objednatel opozdí s uhrazením zálohy. O stejný počet dní se zároveň prodlužuje termín vyhotovení Díla.
						</li>
						<li>
							Termín sjednaný k provedení Díla, uvedený v odstavci 1 tohoto článku se též prodlužuje o počet pracovních dnů, kdy Zhotovitel nebude moci zhotovovat Dílo z důvodů překážek vzniklých na straně Objednatele (viz. nedostatečná součinnost – čl. 6 této smlouvy)
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "cena-zadilo-a-platebni-podminky",
			title: "Článek 4. Cena za dílo a platební podmínky"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Cena za provedení Díla v rozsahu této smlouvy činí: <strong>{data.values["hodnoty-formulare_cena-dila"] || ""}</strong> a bude uhrazena až po oboustranném podepsání protokolu o předání a převzetí Díla (den zdanitelného plnění). Platby budou provedeny do 7 (sedmi) dnů počínaje následujícím dnem po prokazatelném doručení faktury Zhotovitele na adresu Objednatele. Objednatel není v prodlení se zaplacením faktury, pokud nejpozději v poslední den její splatnosti byla částka odepsána z účtu Objednatele ve prospěch účtu Zhotovitele. Zhotovitel je povinen vystavit fakturu nejpozději do 15 (patnácti) dnů ode dne uskutečnění zdanitelného plnění. Dílo bude hrazeno bezhotovostním převodem na účet Zhotovitele, který je veden u České Spořitelny: 3068073349/0800.
						</li>
						<li>
							Zhotovitel má právo na přiměřené zvýšení ceny Díla, objeví-li se při jeho provádění potřeba činností v této smlouvě nezahrnutých, pokud tyto činnosti nebyly předvídatelné v době uzavření této smlouvy a jejich provedení bylo Objednatelem při provádění Díla odsouhlaseno. Ten samý případ nastává pro činnosti dodatečně objednané Objednatelem. Změna rozsahu Díla uvedená v tomto odstavci je považována za vícepráce a Zhotovitel má nárok na jejich úhradu na základě dodatku smlouvy o Dílo, ve kterém budou vícepráce specifikovány, a jejich cena bude vzájemně dohodnuta a Objednatelem odsouhlasena.
						</li>
						<li>
							Objednatel poskytne (uhradí) Zhotoviteli dvě zálohy pro provedení Díla dle této Smlouvy ve výši:
							<ul style={{
								marginTop: "10px",
								lineHeight: "25px",
								textAlign: "justify"
							}}>
								<li>
									<strong>{data.values["hodnoty-formulare_prvni-zaloha"] || ""}</strong>
								</li>
								<li>
									<strong>{data.values["hodnoty-formulare_druha-zaloha"] || ""}</strong>
								</li>
							</ul>
							a to na bankovní účet Zhotovitele, který je veden u České Spořitelny pod číslem 3068073349/0800. Jako variabilní symbol platby bude uvedeno evidenční číslo této smlouvy o Dílo, nebo číslo faktury. Vyrovnání zálohové platby do výše smluvní ceny Díla bude provedeno Objednatelem po řádném dokončení Díla podle smlouvy (podpis „Protokolu o předání a převzetí Díla“).
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "zarucni-doba",
			title: "Článek 5. Záruční doba"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Na předmět této smlouvy dává Zhotovitel Objednateli záruku v délce 36 měsíců.
						</li>
						<li>
							U spotřebičů a ostatních doplňků je záruka dána výrobcem. Vady spotřebičů a ostatních doplňků bude Objednatel v průběhu záruční doby reklamovat písemně doporučeným dopisem na adrese Zhotovitele nebo elektronicky na emailové adrese: <a href="mailto:ztkuchyne@seznam.cz">ztkuchyne@seznam.cz</a>.
						</li>
						<li>
							Záruční doba začíná běžet dnem podpisu protokolu o předání a převzetí Díla. Objednatel převezme dokončené dílo s výhradami, nebo bez výhrad. Případné výhrady budou uvedeny jmenovitě v protokolu o předání a převzetí Díla (viz. čl. 7 odst. 3 této smlouvy).
						</li>
						<li>
							Vady bude Objednatel v průběhu záruční doby reklamovat písemně doporučeným dopisem na adrese Zhotovitele nebo elektronicky na emailové adrese: <a href="mailto:ztkuchyne@seznam.cz">ztkuchyne@seznam.cz</a>. Zhotovitel bezplatně odstraní reklamovanou vadu v místě plnění Díla v dohodnutém termínu. Zhotovitel se zavazuje nastoupit na odstranění vad nejpozději do 10 pracovních dnů od oznámení vady.
						</li>
						<li>
							Případné neodstranitelné vady, které budou bránit užívání předmětu smlouvy, nahradí Zhotovitel Objednateli novým plněním.
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "zavazky-objednatele",
			title: "Článek 6. Závazky Objednatele"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Objednatel se zavazuje poskytnout Zhotoviteli potřebnou dohodnutou součinnost spočívající v:
							<ol style={{
								marginTop: "10px",
								lineHeight: "25px",
								textAlign: "justify"
							}}>
								<li>
									Umožnění zjištění a zaměření přesných údajů a informací potřebných k sestavení návrhu a provedení montáže Zhotovitelem, minimálně 6 týdnů před dohodnutou dobou plnění (viz. doba plnění – čl. 3 této smlouvy), a to formou umožnění přístupu na místo plnění Díla po předchozí telefonické dohodě učiněné v předstihu min. 3 pracovních dnů předem.
								</li>
								<li>
									Umožnění přístupu na místo plnění Díla v termínech dohodnutého data.
								</li>
								<li>
									Neumožní-li Objednatel přístup Zhotoviteli na místo plnění Díla, stanoví Zhotovitel náhradní termín zahájení montáže, předání a převzetí díla, o čemž vyrozumí Objednatele písemně doporučeným dopisem a telefonicky s tím, že tyto termíny nesmí být stanoveny déle než 60 dní od termínů udaného data ve smlouvě. Vyrozumění bude učiněno v předstihu min 5 pracovních dnů předem.
								</li>
							</ol>
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "provedeni-predani-a-prevzeti-dila",
			title: "Článek 7. Provedení, předání a převzetí Díla"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Zhotovitel je povinen předat Dílo Objednateli řádně a včas dle této smlouvy.
						</li>
						<li>
							Objednatel bere na vědomí, že v případě nerovností stavebních konstrukcí, nebude možno dosáhnout přesného slícování dílců s podklady, takže mezi nimi mohou vzniknout přesahy a mezery.
						</li>
						<li>
							Po ukončení montáže bude sepsán předávací protokol, kde zhotovitel svým podpisem potvrdí předání Díla a Objednatel svým podpisem potvrdí jeho převzetí, popřípadě v něm bude uveden i seznam vad a nedodělků a to dle čl. 8. odst. 2 této smlouvy.
						</li>
						<li>
							Objednatel není oprávněn odmítnout převzetí plnění pro drobné vady, které nebrání řádnému užívání Díla.
						</li>
						<li>
							Vlastnictví k Dílu a nebezpečí škody na něm přechází na Objednatele okamžikem převzetí Díla.
						</li>
						<li>
							V případě, že v den ukončení montáže nebude umožněno podepsání předávacího protokolu, tzn., že Objednatel nebude na místě plnění Díla, aby převzal řádně dokončené a bezvadné Dílo, Zhotovitel nebude brát zřetel na pozdější reklamaci na provedení Díla.
						</li>
						<li>
							Osvojení ovládání spotřebičů a doplňků si Objednatel nastuduje z přiložených návodů k použití. Předvedení od Zhotovitele není součástí provedení Díla pro Objednatele.
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "odpovednost-za-vady",
			title: "Článek 8. Odpovědnost za vady"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Záruční doba činí 36 měsíců ode dne převzetí Díla.
						</li>
						<li>
							Zjevné vady, které byly zjištěny již při převzetí Díla a které nebrání řádnému užívání Díla, uvede Objednatel v předávacím protokolu (viz. převzetí Díla s výhradami – čl. 5 odst. 3 této smlouvy). U drobných zjevných vad se Zhotovitel zavazuje provést jejich zhodnocení okamžitě a zavazuje se provést jejich odstranění do 14-ti dnů od převzetí Díla Objednatelem, ve složitějších případech dle dohody mezi Zhotovitelem a Objednatelem.
						</li>
						<li>
							V případě, že Objednatel podepíše protokol o předání a převzetí díla s výhradami, tj. s vadami (včetně drobných vad, které nebudou bránit řádnému užívání díla), může objednatel u platby provést pozastávku ve výši 10% (deseti procent) smluvní ceny díla. Tato pozastávka bude Objednatelem uvolněna po odstranění všech vad.
						</li>
						<li>
							Vady, které nejsou zjevné a které zjistí Objednatel v záruční době, je povinen bez zbytečného odkladu, nejlépe písemně reklamovat u Zhotovitele.
						</li>
						<li>
							Zhotovitel neodpovídá za vady, které byly způsobeny Objednatelem nebo běžným opotřebením.
						</li>
						<li>
							Po dobu od podání písemné reklamace do odstranění vady se staví běh záruční doby.
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "sankce",
			title: "Článek 9. Sankce"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							V případě, že Objednatel bude v prodlení s jakoukoliv platbou, je Zhotovitel oprávněn vyúčtovat Objednateli úrok z prodlení ve výši 0,01% z ceny Díla za každý den prodlení.
						</li>
						<li>
							V případě, že Objednatel bude v prodlení s jakoukoliv platbou delší než 14 dní nebo neumožní-li Objednatel Zhotoviteli přístup na místo plnění ani v náhradním termínu, a Zhotovitel z některého z těchto důvodů odstoupí od smlouvy, je Zhotovitel oprávněn vyúčtovat Objednateli vzniklé a prokázané náklady.
						</li>
						<li>
							V případě, že Zhotovitel bude v prodlení s plněním svých závazků, je Objednatel oprávněn vyúčtovat Zhotoviteli smluvní pokutu ve výši 0,01% z ceny díla za každý den prodlení zhotovitele.
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "zaverecna-ustanoveni",
			title: "Článek 10. Závěrečná ustanovení"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Ustanovení neupravená touto smlouvou se řídí obecně platnými právními předpisy České republiky, zejména zákonem č. 89/2012 Sb., občanským zákoníkem, v platném znění.
						</li>
						<li>
							Změny a doplnění této smlouvy jsou možné pouze v písemné podobě (formou jejího dodatku) a na základě vzájemné dohody obou smluvních stran, není – li uvedeno v této smlouvě jinak.
						</li>
						<li>
							Tato smlouva se uzavírá v českém jazyce ve dvou vyhotoveních s platností originálu, z nichž každá smluvní strana obdrží jedno vyhotovení.
						</li>
						<li>
							Obě smluvní strany prohlašují, že si tuto smlouvu před podpisem přečetly, porozuměly jejímu obsahu, s obsahem souhlasí, a že je tato smlouva projevem jejich svobodné vůle.
						</li>
						<li>
							Veškerá korespondence mezi smluvními stranami bude probíhat písemně na adresách uvedených v záhlaví této smlouvy a elektronicky na emailových adresách Zhotovitele: ztkuchyne@seznam.cz a Objednatele: <strong>{data.values["hodnoty-formulare_email-zakaznika"] || ""}</strong>.
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "platnost-smlouvy",
			title: "Článek 11. Platnost smlouvy"
		}, [
			Row({}, [
				HTMLContent({}, (data) => <>
					<ol style={{
						marginTop: "10px",
						lineHeight: "25px",
						textAlign: "justify"
					}}>
						<li>
							Tato smlouva (včetně příloh Smlouvy č. 1 a č. 2) nabývá platnosti a účinnosti dnem jejího podpisu  smluvních stran.
						</li>
					</ol>
				</>)
			]),
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "podpisova_sekce",
			title: "Potvrzení převzetí formuláře"
		}, [
			Row({
				id: "podpisy"
			}, [
				HTMLContent({}, (data) => <>
					<table style={{
						width: "100%"
					}}>
						<tr>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "30px"
							}}
								colSpan={2}
							>
								V Českých Budějovicích, dne:
                            </td>
						</tr>
						<tr>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "100px"
							}}>
								<p>
									. . . . . . . . . . . . . . . . . . . .
                                </p>
								<p>
									<strong>Podpis a razítko<br />zhotovitele</strong>
								</p>
							</td>
							<td style={{
								width: "50%",
								textAlign: "center",
								verticalAlign: "middle",
								padding: "15px",
								paddingTop: "100px"
							}}>
								<p>
									. . . . . . . . . . . . . . . . . . . .
                                </p>
								<p>
									<strong>Podpis<br />objednatele</strong>
								</p>
							</td>
						</tr>
					</table>
				</>)
			]),
		])
	])
]);